import { useEffect, useRef } from 'react';

import { format, today } from '../../../utils/date';

const makeReportName = (number) => {
  const formatNumber = () => (number < 10 ? `0${number}` : number);
  return `Export ${format(today(), 'YYMMDD')}-${number ? formatNumber() : ''}`;
};

export const useSuggestedReportName = (reports, { condition = true } = {}) => {
  const suggestedReportNameRef = useRef(makeReportName(1));

  useEffect(() => {
    // Detect latest reports
    if (reports.length > 0 && condition) {
      const latestUntitledReport = reports.find(item => item.name.startsWith(makeReportName()));

      if (latestUntitledReport) {
        const latestReportNumber = parseInt(latestUntitledReport.name.split('-')[1], 10);
        suggestedReportNameRef.current = `${makeReportName(latestReportNumber + 1)}`;
      }
    }
  }, [reports]);

  return suggestedReportNameRef;
};
